import '../styles.scss';

import PropTypes from 'prop-types';
import React from 'react';

const Button = ({ children, className, ...buttonProps }) => {
  let btnClassName = 'tertiary-button';

  if (className) {
    btnClassName = `${btnClassName} ${className}`;
  }

  return (
    <button type="button" className={btnClassName} {...buttonProps}>
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Button;
